import { Controller } from "@hotwired/stimulus"

// Wechselt die Carbone-Dokumentenvorlage eines Angebots per fetch
// (kein Page-Reload). Triggert danach den pdf-reader-Controller in der
// Preview, damit er die PDF mit der neuen Vorlage neu rendert.
//
// Erwartet:
//   data-controller="quote-template-switcher"
//   data-quote-template-switcher-url-value="/de/backend/quotes/:id"
//   data-quote-template-switcher-pdf-url-value="/de/backend/quotes/:id.pdf"
//   data-quote-template-switcher-target="status" (optional, für Lade-Hinweis)
//
// Das <select> hat data-action="change->quote-template-switcher#switch".
export default class extends Controller {
  static values = { url: String, pdfUrl: String }
  static targets = ["status"]

  async switch(event) {
    const select = event.target
    const templateId = select.value
    if (this.hasStatusTarget) this.statusTarget.classList.remove("hidden")

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": token || ""
        },
        body: JSON.stringify({ quote: { carbone_template_id: templateId } })
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      this._reloadPdfViewer()
    } catch (err) {
      console.error("[quote-template-switcher] Speichern fehlgeschlagen:", err)
      alert("Dokumentenvorlage konnte nicht gesetzt werden.")
    } finally {
      if (this.hasStatusTarget) this.statusTarget.classList.add("hidden")
    }
  }

  // Setzt den urlValue des pdf-reader mit Cache-Bust und ruft reload() auf.
  _reloadPdfViewer() {
    const el = document.querySelector('[data-controller~="pdf-reader"]')
    if (!el) return
    const freshUrl = this._withCacheBust(this.pdfUrlValue)
    el.setAttribute("data-pdf-reader-url-value", freshUrl)
    // Stimulus-Controller-Instanz holen und reload() rufen
    const app = window.Stimulus || this.application
    const ctrl = app?.getControllerForElementAndIdentifier(el, "pdf-reader")
    if (ctrl?.reload) ctrl.reload()
  }

  _withCacheBust(url) {
    const bust = `_=${Date.now()}`
    return url.includes("?") ? `${url}&${bust}` : `${url}?${bust}`
  }
}
